module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      K.C. Wells\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("K.C. Wells lives on an island off the south coast of the UK, surrounded by natural beauty. She writes about men who love men, and can’t even contemplate a life that doesn’t include writing.")]), _c('P', [_vm._v("The rainbow rose tattoo on her back with the words 'Love is Love' and 'Love Wins' is her way of hoisting a flag. She plans to be writing about men in love - be it sweet and slow, hot or kinky - for a long while to come.")]), _c('P', [_vm._v("If you want to follow her exploits, you can sign up for her monthly newsletter: http://eepurl.com/cNKHlT")]), _c('P', [_vm._v("You can stalk – er, find – her in the following places:")]), _c('P', [_vm._v("Email: k.c.wells@btinternet.com")]), _c('P', [_vm._v("Facebook: "), _c('a', {
    attrs: {
      "href": "http://www.facebook.com/KCWellsWorld"
    }
  }, [_vm._v("www.facebook.com/KCWellsWorld")])]), _c('P', [_vm._v("KC’s men In Love (my readers group): "), _c('a', {
    attrs: {
      "href": "http://bit.ly/2hXL6wJ"
    }
  }, [_vm._v("http://bit.ly/2hXL6wJ")])]), _c('P', [_vm._v("Amazon: "), _c('a', {
    attrs: {
      "href": "https://www.amazon.com/K-C-Wells/e/B00AECQ1LQ"
    }
  }, [_vm._v("https://www.amazon.com/K-C-Wells/e/B00AECQ1LQ")])]), _c('P', [_vm._v("Twitter: @K_C_Wells")]), _c('P', [_vm._v("Website: www.kcwellswrites.com")]), _c('P', [_vm._v("Instagram: "), _c('a', {
    attrs: {
      "href": "http://www.instagram.com/k.c.wells"
    }
  }, [_vm._v("www.instagram.com/k.c.wells")])]), _c('P', [_vm._v("BookBub: "), _c('a', {
    attrs: {
      "href": "https://www.bookbub.com/authors/k-c-wells"
    }
  }, [_vm._v("https://www.bookbub.com/authors/k-c-wells")])])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/aNviNz/tc-custom/9781641086851.jpg?1718183001563",
      "alt": "This image is the cover for the book Out of Sight, Second Sight"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Out of Sight, Second Sight\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Detective Gary Mitchell and psychic Dan Porter have a new cold case to tackle, and new leads to"), _c('br'), _vm._v(" research in the hunt for Gary’s brother’s killer. Their life in Boston has settled into a comfortable"), _c('br'), _vm._v(" rhythm."), _c('br'), _c('br'), _vm._v(" But when forensic discoveries in a recent robbery gone wrong share similarities with their three-"), _c('br'), _vm._v(" year-old cold case, all they can do is follow the evidence—and Dan’s gift—which leads them in"), _c('br'), _vm._v(" an unexpected direction, way out of their comfort zone."), _c('br'), _c('br'), _vm._v(" Gary and Dan find themselves in a shadowy world where they can trust no one, with unseen"), _c('br'), _vm._v(" opponents who want them to back away from their investigation—and suddenly they’re in a race"), _c('br'), _vm._v(" they have to win."), _c('br'), _c('br'), _vm._v(" Because if they don’t, the consequences could be more far-reaching than they could possibly"), _c('br'), _vm._v(" imagine.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    DSP Publications\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0